<template>
  <el-row>
    <el-col :span="7">
       <div class="nowtime">{{nowTime}}</div>
    </el-col>
    <el-col :span="10">
      <div>
        <p class="title">黑龙江省电子信息产业大数据平台</p>
      </div>
    </el-col>
    <el-col :span="7" class="wheather">
      <!-- <div class="weather">
        <a href="https://www.qweather.com/weather/harbin-101050101.html" target="_blank">
        <img src="https://cdn.qweather.com/img/plugin/190516/icon/c/100d.png" :style="{width: '30px', height: '30px'}"/>
        哈尔滨市 27度
       </a>
       </div> -->
    <!-- <el-divider /> -->
    </el-col>
    
  </el-row>
  <div class="bg-line"></div>
  <!-- <el-row> -->
    <!-- <el-col :span="6"> -->
       <!-- <el-divider /> -->
    <!-- </el-col> -->
    <!-- <el-col :span="12"> -->
      <!-- <div class="liuhai">
      </div> -->
    <!-- </el-col>
    <el-col :span="6" class="wheather"> -->
      <!-- <el-divider /> -->
    <!-- </el-col>
  </el-row> -->
</template>
    
<script>
import * as echarts from "echarts";
import {onMounted, onUnmounted, onBeforeMount, ref } from 'vue'
// import hljDataJson from '../static/黑龙江省.json'
export default {
  name: "echartsBox",
  data(){
    return {
      // hljDataJson
    }
  },
  setup() {
    /// 声明定义一下echart
    let echart = echarts;
    const nowTime = ref('');
    const complement = (value) => {
      return value < 10 ? `0${value}` : value.toString();
    }
    const formatDate= ()=>{
      const time = new Date();
      const year = time.getFullYear();
      const month = complement(time.getMonth()+1);
      const day = complement(time.getDate());
      const hour = complement(time.getHours());
      const minute = complement(time.getMinutes());
      const second = complement(time.getSeconds());
      const week = '星期'+ '日一二三四五六'.charAt(time.getDay());
      return `${year}年${month}月${day}日 ${week}  ${hour}:${minute}:${second}`;
    }
    let timer = 0;
    onMounted(() => {
      timer = setInterval(() => {
        nowTime.value = formatDate();
      }, 1000);
    });
    onBeforeMount(()=>{
      clearInterval(timer)
      timer = 0;
    })
    onUnmounted(() => {
      echart.dispose();
    });
    return { nowTime };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.develop{
  height: 88px;
  line-height: 88px;
  text-align: center;
  cursor: pointer;
  color: #fff;
  border: 1PX solid #80D9FB;
  width: 90px;
  margin: 0 auto;
}
.title{
  color: #fff;
  text-align: center;
  font-size: 35px;
  padding: 10px;
  letter-spacing: 3px;
  background:#044ac1;
   border-radius: 0 0 60px 60px;
   position: absolute;
   top: 0;
   width: 100%;
}
.nowtime{
  color: #fff;
  padding-top: 30px;
  font-size:18px;
  text-align: center;
}
.weather{
  padding-top: 16px;
  text-align: center;
}
.weather a{
  color: #fff;
  text-decoration: none;
  font-size: 22px;
}
.weather img{
  vertical-align: middle;
}
.bg-line{
  background-color: #044ac1;
  height: 15px;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  /* top: -70px; */
  /* width: 101%; */
}
.el-row .el-col{
  position: relative;
}
 .liuhai{
  /* width: 100%;
  height: 35px; */
  background:#044ac1;
  /* border-radius: 0 0 30px 30px;
  position: absolute;
  top: 25px; */
 }
</style>
